var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoFaq24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_faq24x24",
    transform: "translate(-3 -3.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(3 3.002)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M208.452,203.289a5.177,5.177,0,0,0-2.839-4.613,7.041,7.041,0,0,1-6.933,6.933,5.163,5.163,0,0,0,7.237,2.122l2.512.695-.695-2.512a5.146,5.146,0,0,0,.718-2.624Zm0,0",
    transform: "translate(-192.452 -192.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M12.195,6.1A6.1,6.1,0,1,0,.845,9.2L.022,12.173,3,11.35a6.1,6.1,0,0,0,9.2-5.252ZM5.162,4.678H4.226A1.871,1.871,0,1,1,7.363,6.06l-.8.727v.729H5.63V6.375l1.1-1.006a.926.926,0,0,0,.3-.691.936.936,0,0,0-1.871,0Zm.468,3.774h.936v.936H5.63Zm0,0",
    transform: "translate(0 -.002)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoFaq24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_faq24x24.42ae77eae8d0bd7196732a3c55378a67.svg";